import { useCallback, type ReactNode } from 'react';
import { Flex, type BoxProps } from '../Core';
import { AccordionChevron } from './AccordionChevron';
import { useAccordionContext } from './AccordionContext';
import { Header } from './styles';

interface AccordionHeaderProps extends Omit<BoxProps, 'prefix' | 'suffix'> {
  children: ReactNode;
  alignChevron?: 'left' | 'right';
  prefix?: ReactNode;
  suffix?: ReactNode;
}

export const AccordionHeader = ({
  children,
  alignChevron = 'right',
  prefix,
  suffix,
  ...props
}: AccordionHeaderProps) => {
  const { headerClickable, toggle, isOpen, ghost } = useAccordionContext();
  const handleHeaderClick: React.MouseEventHandler<HTMLDivElement> = useCallback(
    e => {
      if (headerClickable) {
        toggle(e);
      }
    },
    [headerClickable, toggle]
  );

  return (
    <Header
      justifyContent={alignChevron === 'left' ? 'flex-start' : 'flex-end'}
      clickable={headerClickable}
      ghost={ghost}
      onClick={handleHeaderClick}
      {...props}
    >
      {alignChevron === 'left' && <AccordionChevron toggle={toggle} isOpen={isOpen} />}
      {prefix && prefix}
      <Flex flex="1 0 auto">{children}</Flex>
      {suffix && suffix}
      {alignChevron === 'right' && <AccordionChevron toggle={toggle} isOpen={isOpen} />}
    </Header>
  );
};
